export default "__VITE_ASSET__aa3c8b94__"